export class Response {
  constructor(
    public uid: string,
    public question: string,
    public question_uid: string,
    public response: any,
    public icon: string,
    public type: string
  ) { }
}

